import { Component, computed, input } from '@angular/core';

import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent, BulletComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CamTranslationProject } from '../../../../translation.service';
import { PaymentStatus } from '../../services/dto/payment-status';

export const paymentStatusLabel = (paymentStatus: PaymentStatus) =>
  `project.paymentStatus.${PaymentStatus[paymentStatus]?.toLowerCase() ?? 'unknown'}`;

@Component({
  selector: 'cam-billings-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrl: './payment-status.component.scss',
  imports: [BadgeComponent, BulletComponent, TranslatePipe],
})
export class CamPaymentStatusComponent extends CamBaseComponent {
  status = input.required<PaymentStatus>();

  noLabel = input(false);

  isCreditNote = input(false);

  constructor() {
    super();
    CamTranslationProject.getInstance();
  }

  readonly type = computed<ColorType>(() => {
    switch (this.status()) {
      case PaymentStatus.NotPaid:
        return !this.isCreditNote() ? 'default' : 'purple';
      case PaymentStatus.Paid:
        return 'success';
      case PaymentStatus.PartiallyPaid:
        return 'warning';
      case PaymentStatus.Late:
        return 'alert';
      default:
        return 'default';
    }
  });

  readonly label = computed(() => {
    if (this.noLabel()) {
      return '';
    }
    if (this.status() == PaymentStatus.NotPaid && this.isCreditNote()) {
      return `project.billings.payment-status.to-payback`;
    }
    return `project.billings.payment-status.${PaymentStatus[this.status()].toLocaleLowerCase()}`;
  });
}
